import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import { forwardRef, type FC } from 'react';
import { useResponsiveTooltip } from './useResponsiveTooltip';
import { ClickAwayListener } from '@mui/material';

interface ResponsiveTooltipProps {
  render: (isTooltipOpen: boolean | undefined, onTouchStart: () => void) => JSX.Element;
}

const Layout: FC<ResponsiveTooltipProps> = ({ render }) => {
  const { onTouchStart, onClickAway, isTooltipOpen } = useResponsiveTooltip();

  return (
    <ClickAwayListener onClickAway={onClickAway} mouseEvent={false}>
      {render(isTooltipOpen, onTouchStart)}
    </ClickAwayListener>
  );
};

const TooltipWithRef = forwardRef<HTMLElement, TooltipProps>(({ className, ...props }, ref) => (
  <Tooltip
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          enabled: true,
          phase: 'beforeWrite',
          fn({ state }): void {
            state.styles.popper.zIndex = '9999'; // higher than modal (1300)
          }
        }
      ]
    }}
    {...props}
    ref={ref}
  />
));

TooltipWithRef.displayName = 'TooltipWithRef';

const ResponsiveTooltip = { Tooltip: TooltipWithRef, Layout };

export { ResponsiveTooltip };
